import clsx from 'clsx';
import styles from './TripInfo.module.scss';
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import tripApi from '~/api/tripApi';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { actions, useStore } from '~/store';

function TripInfo({ id, name, onUpdate, onDelete }, ref) {
    const [state, dispatch] = useStore();
    // const { tripId } = state;
    const navigate = useNavigate();
    const [mode, setMode] = useState('showing');
    const [newName, setNewName] = useState(name);
    const refName = useRef();
    const handleOnclickDelete = () => {
        dispatch(actions.setLoading({ loading: true }));
        tripApi
            .delete({ tripId: id })
            .then((res) => {
                // console.log(res);
                if (isSuccess(res)) {
                    toast.success('Xóa thành công');
                    if (onDelete) onDelete({ id });
                } else {
                    toast.error(res.data);
                }
                setMode('showing');

                dispatch(actions.setLoading({ loading: false }));
            })
            .catch((error) => {
                console.log(error);
                toast.error(JSON.stringify(error));
                setMode('showing');
                dispatch(actions.setLoading({ loading: false }));
            });
    };

    const handleOnclickEdit = () => {
        setMode('editing');
    };

    const handleOnclickCancel = () => {
        setMode('showing');
    };

    const handleOnclickSave = () => {
        console.log('newName', newName);
        console.log('name', name);
        if (name !== newName) {
            dispatch(actions.setLoading({ loading: true }));
            console.log('id', id);
            tripApi
                .update({ tripId: id, name: newName })
                .then((res) => {
                    console.log(res);
                    if (isSuccess(res)) {
                        toast.success('Sửa thành công');
                        if (onUpdate) onUpdate({ id, name: newName });
                    } else {
                        toast.error(res.data);
                    }
                    setMode('showing');

                    dispatch(actions.setLoading({ loading: false }));
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(JSON.stringify(error));
                    setMode('showing');
                    dispatch(actions.setLoading({ loading: false }));
                });
        } else {
            setMode('showing');
        }
    };

    const handleOnChangeName = (e) => {
        setNewName(e.target.value);
    };

    const handleFocus = (event) => event.target.select();

    const handleClickName = () => {
        localStorage.setItem('tripId', id);
        localStorage.setItem('tripName', name);
        if (id) {
            const payload = {
                tripId: id,
                tripName: name,
            };
            dispatch(actions.tripChange(payload));
        }
        navigate(`/money`);
    };
    useImperativeHandle(ref, () => ({
        changeMode(mode) {
            setMode(mode);
        },
    }));

    useEffect(() => {
        if (mode === 'editing') {
            if (refName && refName.current) {
                refName.current.focus();
            }
        }
    }, [mode]);

    return (
        <div
            className={clsx(
                styles.wrapper,
                id === state.tripId && styles.active,
            )}
        >
            {mode === 'showing' && (
                <div className={clsx(styles.showing)}>
                    <div className={styles.name} onClick={handleClickName}>
                        {name}
                    </div>
                    <div className={styles.action}>
                        <button
                            className={clsx(styles.btn, styles.delete)}
                            onClick={handleOnclickDelete}
                        >
                            <i className="fa-solid fa-trash-can"></i>
                        </button>
                        <button
                            className={clsx(styles.btn, styles.edit)}
                            onClick={handleOnclickEdit}
                        >
                            <i className="fa-solid fa-pen"></i>
                        </button>
                    </div>
                </div>
            )}
            {mode === 'editing' && (
                <div className={styles.editing}>
                    <input
                        ref={refName}
                        className={styles.name}
                        type="text"
                        value={newName}
                        onChange={handleOnChangeName}
                        onFocus={handleFocus}
                    />
                    <div className={styles.action}>
                        <button
                            className={clsx(styles.btn, styles.cancel)}
                            onClick={handleOnclickCancel}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <button
                            className={clsx(styles.btn, styles.save)}
                            onClick={handleOnclickSave}
                        >
                            <i className="fa-solid fa-check"></i>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default forwardRef(TripInfo);
